// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"189":"10a59b9a","216":"a223dd6f","715":"96b19996"}[chunkId] + ".chunk.css";
};